export default __webpack_public_path__ + "static/media/partners1.a8fcc3d9.png";